import ROLES from "./Roles";
import { hasRole } from "../../../Utils/JWTTokenUtil";


export const ROLE_BASED_ACCESS = {
  SCTK: () => hasRole(ROLES.SCTK),
  RELEASE_MANAGEMENT: () => hasRole(ROLES.RELEASE_MANAGEMENT),
  MULTI_DEPLOYMENT: () => hasRole(ROLES.MULTI_DEPLOYMENT),
  AWS_MANAGEMENT: () =>
    hasRole(ROLES.AWS_SECRETS_MANAGER) ||
    hasRole(ROLES.AWS_PARAMETER_STORE_MANAGER) ||
    hasRole(ROLES.AWS_CACHE_MANAGER),
  AWS_SECRETS_MANAGER: () => hasRole(ROLES.AWS_SECRETS_MANAGER),
  AWS_PARAMETER_STORE_MANAGER: () => hasRole(ROLES.AWS_PARAMETER_STORE_MANAGER),
  AWS_CACHE_MANAGER: () => hasRole(ROLES.AWS_CACHE_MANAGER),
  IAC_TFSTATE_UNLOCK: () => hasRole(ROLES.IAC_TFSTATE_UNLOCK),
  UTILS: () => hasRole(ROLES.UTILS),
  ROLE_MANAGEMENT: () => hasRole(ROLES.ROLE_MANAGEMENT),
  USER_MANAGEMENT: () => hasRole(ROLES.USER_MANAGEMENT),
  TENANT_MANAGEMENT: () => hasRole(ROLES.TENANT_MANAGEMENT),
  AI_MODE: () => hasRole(ROLES.AI_MODE),
  AI_MODE_SDLC: () =>  hasRole(ROLES.AI_MODE) && hasRole(ROLES.AI_MODE_SDLC),
  AI_CHAT_AGENT: () => hasRole(ROLES.AI_MODE) && hasRole(ROLES.AI_CHAT_AGENT),
  AI_SETTINGS: () => hasRole(ROLES.AI_MODE) && hasRole(ROLES.AI_SETTINGS),
};